import createApi from 'api/createApi';

export const tags = {
	aiChat__send: 'mw/ai-chat/send',
};

export const aiChatApi = createApi({
	reducerPath: 'mw/aiChatApi',

	endpoints: (builder) => ({
		sendMessage: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/ai-chat/send',
				body,
				jsonType: true,
			}),
			providesTags: [tags.aiChat__send],
		}),
	}),
});

export const {
	sendMessage,
} = aiChatApi.endpoints;

export default aiChatApi;
